"use client";

import { useEffect } from "react";

export default function CSVBoxStyler() {
  useEffect(() => {
    let holder = null;
    let holderObserver = null;
    let styled = false;

    function applyOpen() {
      if (styled) return;
      styled = true;

      document.body.style.overflow = "hidden";
      holder.style.pointerEvents = "auto";

      document.addEventListener("keydown", onKey);
    }

    function applyClose() {
      if (!styled) return;
      styled = false;

      document.body.style.removeProperty("overflow");
      holder.style.display = "none";
      holder.style.removeProperty("pointer-events");

      document.removeEventListener("keydown", onKey);
    }

    function forceClose() {
      applyClose();
      window.postMessage("mainModalHidden", "*");
    }

    function onKey(e) {
      if (e.key === "Escape") forceClose();
    }

    function onHolderStyle() {
      if (!holder) return;
      const display = holder.style.display;
      if (display === "block" || display === "flex") {
        applyOpen();
      } else {
        applyClose();
      }
    }

    function attachToHolder() {
      const el = document.querySelector(".csvbox-iframe");
      if (!el?.parentElement) return false;
      holder = el.parentElement;
      holderObserver = new MutationObserver(onHolderStyle);
      holderObserver.observe(holder, { attributes: true, attributeFilter: ["style"] });
      return true;
    }

    const bodyObserver = new MutationObserver(() => {
      if (attachToHolder()) bodyObserver.disconnect();
    });

    if (!attachToHolder()) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    return () => {
      bodyObserver.disconnect();
      holderObserver?.disconnect();
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  return null;
}
